export { default as admantx } from './Admantx';
export { default as xfinity } from './Xfinity';
